export default __webpack_public_path__ + "static/media/education.31e4b29d.jpg";